module.exports = __webpack_public_path__ + "img/s4Model2.bd683de7.png";